'use client';

interface OptionButtonProps {
  option: string;
  value: string;
  optionClick: (option: string) => void;
}

const OptionButton = ({ option, value, optionClick }: OptionButtonProps) => {
  return (
    <button type="button" className={`w-full px-3 py-2 text-left hover:bg-gray-50 flex items-center justify-between ${value === option ? 'bg-gray-50' : ''}`} onClick={() => optionClick(option)}>
      <span>{option}</span>
      {value === option && <i className="ri-check-line"></i>}
    </button>
  );
};

export default OptionButton;
